import { VIEW_POSITIONING_CONFIGURATION_BY_REGISTRY } from '../../schema/positioningConfigurations';
import { parse, toSeconds } from 'iso8601-duration'; 

export default {
    namespaced: true,
    state: {
        configuration: undefined,
    },
    
    getters: {
        configuration: (state) => state.configuration,
    },
    mutations: {
        set_configuration: (state, configuration) => {
            state.configuration = configuration;
            state.configuration.recent_position_duration = toSeconds(parse(configuration.recent_position_duration));
            state.configuration.lost_position_delay = toSeconds(parse(configuration.lost_position_delay));
        },
    },
    actions: {
        get: ({ commit, rootGetters }, payload) => {
            return new Promise((resolve, reject) => {
                rootGetters.apollo.query({
                    query: VIEW_POSITIONING_CONFIGURATION_BY_REGISTRY,
                    variables: {
                        projectId: parseInt(payload.project_id),
                        registryId: parseInt(payload.registry_id),
                    },
                    fetchPolicy: 'no-cache',
                    notifyOnNetworkStatusChange: true
                }).then(({ data, loading }) => {
                    if (!loading && data !== undefined) {
                        commit('set_configuration', data.positioningConfiguration);
                        resolve(data.positioningConfiguration);
                    } 
                }).catch((error) => {
                    console.error(error.message);
                    reject(error);
                });
            });
        },
    }
};